
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Badge extends Vue {
  @Prop([String, Number]) readonly badgeValue!: string | number;
  @Prop(String) readonly badgeIcon!: string;
  @Prop(Number) readonly minValue!: number;
  @Prop(String) readonly align!: string;
  @Prop(String) readonly badgeColor!: string;
  @Prop(String) readonly badgeOutlineColor!: string;

  checkMinValue() {
    if (this.badgeValue && this.minValue) {
      if (typeof this.minValue !== typeof this.badgeValue) {
        console.warn('Badge minValue and badgeValue not matching type, skipping condition');
        return true;
      } else {
        return this.badgeValue >= this.minValue;
      }
    }
    
    return true;
  }

  getColor(outlineColor: string) {
    if (outlineColor.indexOf('#') > -1) {
      return outlineColor;
    }

    if (this.$vuetify.theme.currentTheme) {
      for (const [colorIndex, color] of Object.entries(this.$vuetify.theme.currentTheme)) {
        if (outlineColor === colorIndex) {
          return color + '';
        }
      }
    }

    return outlineColor;
  }

  getClass() {
    let classes = this.align === 'icon' ? 'badge--icon' : '';
    classes += this.align === 'icon-right' ? 'badge--icon-right' : '';
    classes += this.align === 'icon-alt' ? 'badge--icon-alt' : '';

    return classes;
  }

  getXOffset() {
    if (this.align === 'icon') {
      return 22;
    }

    if (this.align === 'icon-right') {
      return 4;
    }

    if (this.align === 'icon-alt') {
      return 11;
    }

    return 6;
  }

  getYOffset() {
    if (this.align === 'icon') {
      return -5;
    }

    if (this.align === 'icon-right') {
      return 6;
    }

    if (this.align === 'icon-alt') {
      return 11;
    }

    return 18;
  }
}
